export type Out = ">>"
export const OUT: Out = ">>"

export type In = "<<"
export const IN: In = "<<"
